export default __webpack_public_path__ + "static/media/cross.4f70d802.svg";